import { QuadtreeUtils } from "../../utils/internal";
/**
 * A Data Tile of Quadtree-Disparty
 * @class DisparityTile
 * @param quadcode
 * @param baseurl
 * @constructor
 * @param {string} quadCode
 * @param {string} baseUrl
 */
export class DisparityTile {
    /**
     * @method constructor
     * @param quadCode
     * @param path
     * @param imageWidth
     * @param imageHeight
     * @param tileSize
     * @param traversalState
     * @param callback
     * @param callbackEmpty
     * @param sensorid
     */
    constructor(quadCode, path, imageWidth, imageHeight, tileSize, traversalState, callback, callbackEmpty, sensorid) {
        this.tileSize = 512;
        this.disparityMap = null;
        this.extent = [];
        this.noData = false; // nodata tiles do not exist physically (i.e. not stored on disk)
        this._dataReadyCallback = null;
        this._dataEmptyCallback = null;
        /**
         * true = disparity map loading is initialized. is set to true - once asyncDownload was called.
         * is set to false by disparity quadtree.
         * @type {boolean}
         */
        this.initialized = false;
        this.path = path;
        this.traversalState = traversalState;
        this.quadCode = quadCode;
        this._dataReadyCallback = callback;
        this._dataEmptyCallback = callbackEmpty;
        this.noData = false;
        this.extent = QuadtreeUtils.QuadKeyToNormalizedCoord(quadCode);
        this.imageWidth = imageWidth;
        this.imageHeight = imageHeight;
        this.tileSize = tileSize;
        this.sensorid = sensorid;
        this.initialized = false;
        // check if this tile exists, if not set it to a "no data tile"
        if (this.extent[0] > imageWidth || this.extent[1] > imageHeight) {
            this.noData = true; // this is a nodata tile.
        }
        else {
            this._asyncDownload();
        }
    }
    /**
     * reloads the disparity map using a new path
     * @param {string} path
     */
    loadTexture(path) {
        this.path = path;
        if (this.disparityMap)
            this.disparityMap.destroy();
        this.disparityMap = null;
        this._asyncDownload();
    }
    /**
     * download tile is background
     * @method _AsyncDownload
     * @private
     */
    _asyncDownload() {
        const result = QuadtreeUtils.QuadKeyToTileCoord(this.quadCode), x = result.x, y = result.y, lod = result.lod;
        //download disparity map
        const disparity_url = this.path + "/?lod=" + lod + "&x=" + x + "&y=" + y;
        const engine = this.traversalState.scene.engine;
        engine.requestDispMap(disparity_url, (dispmap) => {
            this.dispMapLoaded(dispmap);
        }, (dispmap) => {
            this.dispMapLoadingFailed(dispmap);
        }, false, this);
        this.initialized = true;
    }
    dispMapLoaded(dispMap) {
        this.disparityMap = dispMap;
        this.disparityMap.disparityContext.drawImage(dispMap.image, 0, 0);
        if (this._dataReadyCallback)
            this._dataReadyCallback(this);
    }
    dispMapLoadingFailed(dispMap) {
        this.disparityMap = dispMap;
        if (this._dataEmptyCallback)
            this._dataEmptyCallback(this);
    }
    /**
     * Test if Disparitymap is available
     * @method isAvailable
     * @return {boolean}
     */
    isAvailable() {
        if (this.noData)
            return true; // return no data value if this is a no data tile
        if (this.disparityMap == null)
            return false;
        return this.disparityMap.ready;
    }
    /**
     * Free all memory.
     * (This function is automatically called from TileCache)
     * @method destroy
     */
    destroy() {
        // The disparity map is stored in the engine cache, so we do not
        // dispose it here. We just remove the reference to it.
        this.disparityMap = null;
        this.path = "";
        this.quadCode = "";
        this.tileSize = 0;
        this.extent = [];
        this.noData = false;
        this.imageWidth = 0;
        this.imageHeight = 0;
        this.traversalState = null;
        this._dataReadyCallback = null;
        this._dataEmptyCallback = null;
    }
    /**
     * Retrieve Disparity value at specified map position
     * returns -1 if tile is not yet loaded.
     * returns 0 if there is no data
     * @method getDisparityValue
     * @param {number} px map coordinate x (not mouse coord!)
     * @param {number} py map coordinate y (not mouse coord!)
     * @param {boolean} cachedata
     * @return {number[]|number}
     */
    getDisparityValue(px, py, cachedata = true) {
        if (this.isAvailable()) {
            // calculate pixel coordinate
            // with of one pixel:
            const pixelwidth = this.tileSize / (this.extent[2] - this.extent[0]);
            let posx = Math.floor(pixelwidth * (px - this.extent[0]) + 0.5);
            let posy = Math.floor(pixelwidth * (py - this.extent[1]) + 0.5);
            // clamp to [0,tilewidth-1]
            if (posx < 0)
                posx = 0;
            if (posx > this.tileSize - 1)
                posx = this.tileSize - 1;
            if (posy < 0)
                posy = 0;
            if (posy > this.tileSize - 1)
                posy = this.tileSize - 1;
            // return value using pixel based query:
            return this.disparityMap.getDisparityValue(posx, posy, cachedata);
        }
        if (this.noData)
            return 0;
        return -1;
    }
}
//# sourceMappingURL=disparitytile.js.map